import { MapPin, ExternalLink } from 'lucide-react';

// Placeholder isolado — será substituído pelo Google Maps JS API na Fase 4.
// Já entrega valor real: link direto para o Google Maps com as coordenadas
// ou endereço do evento.
export function EventMapPlaceholder({ location, city, latitude, longitude }) {
  const mapsUrl = latitude && longitude
    ? `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`
    : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${location}, ${city}`)}`;

  return (
    <div className="rounded-xl overflow-hidden border bg-muted/50">
      {/* Área do mapa */}
      <div className="relative h-36 flex items-center justify-center bg-gradient-to-br from-slate-100 to-slate-200 dark:from-slate-800 dark:to-slate-900">
        {/* Grade decorativa que simula um mapa */}
        <svg
          className="absolute inset-0 w-full h-full opacity-20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <pattern id="map-grid" width="24" height="24" patternUnits="userSpaceOnUse">
              <path d="M 24 0 L 0 0 0 24" fill="none" stroke="currentColor" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#map-grid)" />
        </svg>

        {/* Marcador central */}
        <div className="relative z-10 flex flex-col items-center gap-1">
          <div className="w-10 h-10 rounded-full bg-primary/90 flex items-center justify-center shadow-lg">
            <MapPin className="w-5 h-5 text-primary-foreground" />
          </div>
        </div>
      </div>

      {/* Rodapé com link */}
      <a
        href={mapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-between px-4 py-2.5 text-sm text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors"
      >
        <span>Ver no Google Maps</span>
        <ExternalLink className="w-3.5 h-3.5 flex-shrink-0" />
      </a>
    </div>
  );
}
